import React from 'react';

import Questions from '@/components/Questions';

const Accordion = () => {
  const questionsAnswers = [
    {
      question: '中文-常见问题-课程介绍-标题',
      answer: '中文-常见问题-课程介绍-答案',
      id: 1,
    },
    {
      question: '中文-常见问题-简要的学员能力-标题',
      answer: '中文-常见问题-简要的学员能力-答案',
      id: 2,
    },
    {
      question: '中文-常见问题-授课形式-标题',
      answer: '中文-常见问题-授课形式-答案',
      id: 3,
    },
    {
      question: '中文-常见问题-价格与购课-标题',
      answer: '中文-常见问题-价格与购课-答案',
      id: 4,
    },
    {
      question: '中文-常见问题-课程预约-标题',
      answer: '中文-常见问题-课程预约-答案',
      id: 5,
    },
    {
      question: '中文-常见问题-老师-标题',
      answer: '中文-常见问题-老师-答案',
      id: 6,
    },
  ];

  return (
    <Questions
      questionsAnswers={questionsAnswers}
      useTranslationName="chinese"
      className="marginModelTop container mb-20  lg:mb-[100px]  xl:mb-40 "
      subject="chinese"
    />
  );
};

export default Accordion;
